var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errors-info-wrapper spacex-8"},[_c('CheckIcon',{staticClass:"icon-20px"}),_c('span',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.$t('All correct')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }